import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagTO(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURcUIEs4KFdsOGf39/fLy8vf396lDmDwAAAFJSURBVDjL5ZJBTwMhFISHRO+Aei9r+gfa7L0mcNcW/v9fcebB2qa7Bw/qxdkCjzcf0y0pjitNt9rhx4DDNL3+FjB3Cbh0bQPnKe67P98B1mztHON+bhc+7Q5gaz7EGGJIZLhZJbTWPmiGEFJ4avM6QUCimfh50W4LCEPfBGKio8HKgHKW6Tj2AhL7iROVJo9SSmX3HZ7HqzSZKcwS2Ckl15PHY7W6JtmLdig5s1tOwEMufHKWa4y+ZIdcK5tZAIOUFmREzfzpHlkJHchdPKpb1RSiAdIb8DxKs3lzRnwBN6IXzBexCejWjaC2Adnd50uGtdJY9SKbwK3+BHBr+cDByUsjwev/4JfaSnJcoAR4Z3Q/4v2SoDAPcwZiKwc0q+bKCPRj423QKTcY81WiW8AI6lmQ1JQNN3aLATs1tLDDctfyKoeVPP6NPgHLxpfog9SC9AAAAABJRU5ErkJggg==",
    alt: "TO"
  }, props));
}